import React from 'react'

import HubSpotForm from '../form/HubSpotForm'

const InitialSetup = () => {
  return (
    <div className="content-wrapper">
      <div className="container">
        <div className="row">
          <h2 className="page-title">Welcome to Headed2</h2>
        </div>
      </div>
      <div
        className="title-block-bar"
        style={{ paddingTop: '75px', backgroundColor: '#53ad64' }}>
        <div className="container">
          <h3 style={{ fontSize: '1.6rem', color: 'white', marginBottom: '20px' }}>
            Were excited to get you up and running with the Career Explorer.
          </h3>
        </div>
      </div>

      <div className="container" style={{ marginTop: '25px', marginBottom: '25px' }}>
        <HubSpotForm showTitle={true} formId="c99a7ac4-0386-41b4-ba46-fe2492fccb4f" />
      </div>
    </div>
  )
}

export default InitialSetup
